/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1669
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 168 */"./1648/168")
var /* [auto-meaningful-name] */require_1083_$_1581_1083$f = require(/* 1083 */"./1581/1083").f
r({
  target: "Object",
  stat: true,
  forced: o(function () {
    return !Object.getOwnPropertyNames(1)
  })
}, {
  getOwnPropertyNames: require_1083_$_1581_1083$f
})
